import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/cn';
const SIZE = {
    sm: 'h-9 w-9',
    md: 'h-11 w-11',
    lg: 'h-12 w-12',
};
const SHAPE = {
    rounded: 'radius-control',
    circle: 'radius-avatar',
    // 'card' radius for hero tiles, with a brand gradient fill applied
    // unconditionally below.
    gradient: 'radius-card bg-gradient-to-br from-brand-500 to-violet-600 text-white',
};
const TONE = {
    indigo: 'bg-brand-100  text-brand-700  dark:bg-brand-950/40  dark:text-brand-300',
    sky: 'bg-sky-100     text-sky-700     dark:bg-sky-950/40     dark:text-sky-300',
    amber: 'bg-amber-100   text-amber-800   dark:bg-amber-950/40   dark:text-amber-300',
    rose: 'bg-rose-100    text-rose-700    dark:bg-rose-950/40    dark:text-rose-300',
    emerald: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300',
    slate: 'bg-slate-100   text-slate-700   dark:bg-slate-800      dark:text-slate-200',
};
export function IconTile({ size = 'md', shape = 'rounded', tone = 'indigo', className, children, }) {
    return (_jsx("div", { className: cn('inline-flex shrink-0 items-center justify-center', SIZE[size], SHAPE[shape], 
        // Gradient owns its own colours; the tone palette only applies to
        // the flat fills.
        shape !== 'gradient' && TONE[tone], className), "aria-hidden": "true", children: children }));
}
